import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSimCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSimCard2"><Path d="M20 2V22H4V6.43934L8.43934 2H11.5V8H13V2H15.5V8H17V2H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSimCard2;
